import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

//MUI
import { Typography, IconButton } from "@mui/material";

//Icons
import { ReactComponent as ChevronLeft } from "../../../../../assets/icons/svg/chevron-left.svg";
import { ReactComponent as TrashIcon } from "../../../../../assets/icons/svg/trash.svg";
import { ReactComponent as EllipsisIcon } from "../../../../../assets/icons/svg/ellipsis.svg";

//Utils
import { convertToTitleCase } from "../../../../../utils/recipe";

//Actions
import { closeItemModal } from "../../../../../actions/pantry";

export const PantryItemModalNav = ({ item: { loading, error, data }, closeItemModal }) => {
  return (
    <div className="p-4 flex items-center justify-between bg-neutral-100">
      <div className="flex items-center">
        <IconButton size="small" className="hover:bg-transparent" disableRipple onClick={() => closeItemModal()}>
          <ChevronLeft className="h-4 w-full fill-primaryText" />
        </IconButton>

        <div className="ml-4">
          <Typography variant="h6" className="font-normal">
            {convertToTitleCase(data?.display?.ingredient?.names?.default || "Pantry Item")}
          </Typography>
          {data?.display?.brand && (
            <Typography className="text-mainGreen" variant="subtitle1">
              {data?.display?.brand}
            </Typography>
          )}
        </div>
      </div>

      <div className="flex items-center gap-2">
        <div>
          <IconButton size="small">
            <EllipsisIcon className="h-auto w-4 fill-primaryText" />
          </IconButton>
        </div>
      </div>
    </div>
  );
};

PantryItemModalNav.propTypes = {
  item: PropTypes.object.isRequired,
  closeItemModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  item: state.pantry.item,
});

export default connect(mapStateToProps, { closeItemModal })(PantryItemModalNav);
